module.exports = __webpack_public_path__ + "static/weSupport-1a0daacf752c9df064d722ec3241fac2.png";